export default "/images/6d97f08b78e9dcbf1ab6553b0724d926.png";